import { render } from "./PasswordResetLink.vue?vue&type=template&id=73a7807a"
import script from "./PasswordResetLink.vue?vue&type=script&lang=js"
export * from "./PasswordResetLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__